import { render, staticRenderFns } from "./condicion_fisica.vue?vue&type=template&id=6bd8aea7&"
import script from "./condicion_fisica.vue?vue&type=script&lang=js&"
export * from "./condicion_fisica.vue?vue&type=script&lang=js&"
import style0 from "./condicion_fisica.vue?vue&type=style&index=0&id=6bd8aea7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports